import React from "react";
import { motion } from "framer-motion";
import classes from "./Temp.module.css";

const ServiceTemp = ({ name, image, description, index }) => {
  const cardVariants = {
    hidden: { opacity: 0, y: 40 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: [0.4, 0, 0.2, 1] },
    },
  };

  return (
    <motion.div
      className={classes.ServiceTemp}
      variants={cardVariants}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: false, amount: 0.3 }}
    >
      <motion.div
        className={classes.ServiceImage}
        initial={{ opacity: 0, scale: 0.8 }}
        whileInView={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.6, delay: 0.2 }}
        viewport={{ once: false, amount: 0.4 }}
      >
        <img src={image} alt={name} />
        <h2 className={classes.TempName}>{name}</h2>
      </motion.div>

      <motion.div
        className={classes.ServiceText}
        initial={{ opacity: 0, x: 40 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.6, delay: 0.3 }}
        viewport={{ once: false, amount: 0.4 }}
      >
        <p>{description}</p>
      </motion.div>
    </motion.div>
  );
};

export default ServiceTemp;
